"use client";

import { ChevronLeftIcon } from "@chakra-ui/icons";
import { Box, Flex, Heading, Link } from "@chakra-ui/react";
import RouterLink from "next/link";
import { ReactNode } from "react";
import { ContentfulImage } from "../../../components/ContentfulImage";
import { NotFoundComponent } from "../../not-found-component";

import type { ContentGallery } from "../../content";

type Props = {
  gallery: ContentGallery | null;
};

export function PageComponent(props: Props): ReactNode {
  const { gallery } = props;

  return gallery ? (
    <>
      <Heading mb={4}>{gallery.title}</Heading>
      <Link as={RouterLink} href="/bilder" color="blue.500">
        <ChevronLeftIcon />
        zurück
      </Link>
      <Flex wrap="wrap">
        {gallery.images.map((imageUrl) => (
          <Box
            key={imageUrl}
            as="a"
            href={imageUrl}
            target="_blank"
            display="inline-flex"
          >
            <Box
              mt={4}
              mr={4}
              display="inline-flex"
              rounded="lg"
              overflow="hidden"
            >
              <ContentfulImage
                src={imageUrl}
                alt={`Bild für die Veranstaltung ${gallery.title}`}
                height={258}
                width={387}
                style={{ objectFit: "cover" }}
              />
            </Box>
          </Box>
        ))}
      </Flex>
    </>
  ) : (
    <NotFoundComponent />
  );
}
